import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_APPT_DATA_SUCCESS
    FETCH_SLOTS
    FETCH_SLOTS_SUCCESS
    FETCH_SLOTS_FAILURE
    SUBMIT_EDIT_SUCCESS
    SET_BRANCH
    SET_DATE
    SET_CITY
    SET_TIME
    SET_SELECTED_INSPECTION_TYPE
    RESET_RESPONSE_KEY
    UPDATE_COORDINATES
`,
    {
        prefix: "editbooking/"
    }
);
